const PsIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      stroke="none"
      viewBox="0 0 28 23"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="inherit">
        <path d="M4.56 17.912c.9.21 1.84.16 2.71-.14l2.24-.81v2.35l-.44.07c-2.34.38-4.73.19-6.98-.56-2.19-.62-2.56-1.9-1.56-2.65.78-.51 1.62-.91 2.5-1.2l6.49-2.3v2.63l-4.67 1.67c-.83.3-.95.72-.28.93M27.55 16.99c-.53.52-1.17.92-1.87 1.17l-9.9 3.56V19.1l7.28-2.6c.83-.3.96-.71.28-.93a4.9 4.9 0 00-2.71.14l-4.85 1.71V14.7l.28-.09c1.1-.35 2.23-.59 3.38-.71 2.12-.22 4.27.04 6.28.75 2.14.67 2.38 1.67 1.83 2.35" />
        <path d="M16.719 12.52v-6.7c0-.78-.14-1.51-.88-1.71-.57-.18-.92.34-.92 1.13v16.78l-4.53-1.44V.57c2.11.45 4.2 1.02 6.24 1.71 3.83 1.32 5.13 2.96 5.13 6.65 0 3.69-2.22 4.96-5.04 3.6" />
      </g>
    </svg>
  )
}
export default PsIcon
